/**
 * Name of the route parameter carrying the admin case ID.
 */
export const caseIdPathParam = 'caseId';

/**
 * Name of the route parameter carrying the client ID within a case.
 */
export const clientIdPathParam = 'clientId';

/**
 * Name of the route parameter carrying the claim ID.
 */
export const claimIdPathParam = 'claimId';

/**
 * Name of the route parameter carrying the claim template ID.
 */
export const claimTemplateIdPathParam = 'claimTemplateId';

/**
 * Name of the route parameter carrying the email template ID. Route currently disabled.
 */
export const emailTemplateIdPathParam = 'emailTemplateId';
